export default "__VITE_ASSET__CCu45OMY__"